import { useHistory } from 'react-router-dom';

import { Button } from '@library/buttons/Button';

import { Prompt } from '../../shared/Prompt';
import { PromptContent } from '../../shared/PromptContent';
import { PromptHeader } from '../../shared/PromptHeader';
import { ROUTES } from './constants';

export const AskToSetPassword = () => {
  const history = useHistory();
  return (
    <Prompt data-cy="ask-set-password" variant="auth">
      <PromptHeader
        title="You're in!"
        subtitle="Want to take this moment to set a new password for your account?"
        logoType="icon"
      />
      <PromptContent>
        <Button
          isPrimary
          onClick={() => {
            history.push(`.${ROUTES.SET_NEW_PASSWORD}`);
          }}
        >
          Yes, set my password
        </Button>
        <Button
          data-cy="set-password-later-btn"
          onClick={() => history.push('/inbox')}
        >
          Set my password later
        </Button>
      </PromptContent>
    </Prompt>
  );
};
